import { Fragment, useCallback, useEffect, useState } from 'react';

import axiosApiInstance from '@/api/shared/axios-instance';
import { REDUCERS } from '@/constants/reducers';
import URL_FACTORY from '@/helpers/url-helper';

import ShowMarketProjectionTable from './ShowMarketProjectionTable';
import useSpinner from '@/DesignSystem/hooks/useSpinner';
import { notifyError } from '@/notifications/notify';
import CustomDrawer from '@/DesignSystem/components/drawer/CustomDrawer';
import JugadoresDrawerComponentHeader from '../common/JugadoresDrawerComponentHeader';
import PlacementModalComponent from '@/components/ads-components/placements/placementModal';
import { Box } from '@mui/material';

const ShowMarketProjectionComponent = ({ marketProjection, dispatch }) => {
    const [open, setOpen] = useState(false);

    const [data, setData] = useState(null);
    const [cache, setCache] = useState([]); // Estado para la caché

    const { showSpinner, hideSpinner } = useSpinner();

    const handleClose = useCallback(() => {
        setOpen(false);
        setData(null);

        dispatch({
            type: REDUCERS.SHOW_MARKET_PROJECTION,
            payload: null,
        });
    }, [dispatch]);

    useEffect(() => {
        if (marketProjection > 0) {
            // Verificamos si el resultado está en la caché
            const isCached = cache.find((x) => x.marketProjectionId === marketProjection);

            if (isCached) {
                setData(isCached.data);
                setOpen(true);
                return;
            }

            showSpinner();

            // Si no está en la caché, hacemos la solicitud
            axiosApiInstance
                .get(URL_FACTORY.GetPlayerProjection(marketProjection))
                .then((response) => {
                    if (response?.data) {
                        setData(response.data);
                        setOpen(true);

                        // Agregamos el resultado a la caché
                        setCache((prevCache) => [
                            ...prevCache,
                            {
                                marketProjectionId: marketProjection,
                                data: response.data,
                            },
                        ]);
                    }
                })
                .catch((_error) => {
                    notifyError('Error al obtener la proyección de mercado');
                })
                .finally(() => {
                    hideSpinner();
                });
        }
    }, [marketProjection, cache]);

    if (!data) {
        return null;
    }

    return (
        <CustomDrawer
            title="Proyección de Mercado"
            open={open}
            onClose={handleClose}
            pagerProps={{ overflowX: 'hidden' }}
        >
            <JugadoresDrawerComponentHeader
                id={data?.id}
                name={data?.name}
                teamId={data?.teamId}
                status={data?.status}
                statusLevel={data?.statusLevel}
                marketValue={data?.marketValue}
                subida={data?.subida}
                points={data?.points}
                averagePoints={data?.averagePoints}
                fitness={data?.fitness}
            />

            <PlacementModalComponent />

            <ShowMarketProjectionTable projections={data?.projections} />
        </CustomDrawer>
    );
};

export default ShowMarketProjectionComponent;
